import type { SVGProps } from 'react';
const SvgRemove = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#remove_svg__a)">
      <path fill="currentColor" d="M19 13H5v-2h14v2Z" />
    </g>
    <defs>
      <clipPath id="remove_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgRemove;
